import { OptionCurrency } from "../types/option-currency.interface"

export const optionsCurrency: OptionCurrency[] = [
    { id: "--", value: "--" },
    { id: "MXN", value: "MXN" },
    { id: "USD", value: "USD" },
    { id: "EUR", value: "EUR" },
    { id: "CAD", value: "CAD" },
]
